<template>
  <b-form-group
    :label="label"
    :label-for="name"
    :description="helptext"
  >
    <date-range-picker
      ref="picker"
      opens="center"
      :locale-data="{ firstDay: 0, format: 'YYYY-MM-DD HH:mm:ss' }"
      :minDate="minDate"
      :maxDate="maxDate"
      :singleDatePicker="singleDatePicker"
      :timePicker="timePicker"
      :timePickerIncrement="1"
      :timePickerSeconds="timePickerSeconds"
      :timePicker24Hour="true"
      :showDropdowns="showDropdowns"
      :autoApply="autoApply"
      :ranges="false"
      v-model="state"
      @update="updateValues"
      :linkedCalendars="linkedCalendars"
    >
      <div slot="input" slot-scope="picker" class="datepicker-style" v-html="showDateText(picker)">
        {{ picker }}
      </div>
    </date-range-picker>
    <div v-if="formHandle.$error">
      <div class="invalid-feedback d-block" v-for="error in errors" :key="error">{{ errorMessage[error] }}</div>
    </div>
  </b-form-group>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment-timezone'

export default {
  data: () => {
    return {
      state: ''
    }
  },
  props: {
    minDate: {
      type: String,
      default: null
    },
    maxDate: {
      type: String,
      default: null
    },
    singleDatePicker: {
      type: Boolean,
      default: true
    },
    timePicker: {
      type: Boolean,
      default: false
    },
    timePickerSeconds: {
      type: Boolean,
      default: true
    },
    showDropdowns: {
      type: Boolean,
      default: false
    },
    autoApply: {
      type: Boolean,
      default: true
    },
    linkedCalendars: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ''
    },
    model: {
      type: String | Number
    },
    name: {
      type: String,
      default: ''
    },
    handler: {
      type: Array | Object
    },
    formData: {
      type: Array | Object
    },
    disabled: {
      type: Boolean,
      default: false
    },
    helptext: {
      type: String
    }
  },
  components: {
    DateRangePicker
  },
  model: {
    prop: 'model',
    event: 'updateModel'
  },
  created () {
    this.state = this.model
  },
  watch: {
    'model': function () {
      this.state = this.getDateFormat(this.model)
    }
  },
  methods: {
    showDateText (date) {
      let value = this.state
      if (date.startDate || date.endDate) {
        value = this.getDateFormat(date)
      }
      if (this.singleDatePicker) {
        return (!value) ? `<div>Select Date</div>` : `<div>${value}</div>`
      }
      return (!value) ? `<div>Start Date</div><span>-</span><div>End Date</div>` : `<div>${value[0]}</div><span>-</span><div>${value[1]}</div>`
    },
    getDateFormat (date) {
      if (!this.state) return null
      let format = (this.timePicker) ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD'
      if (this.singleDatePicker) {
        return moment(date.startDate).format(format)
      }
      return [ moment(date.startDate).format(format), moment(date.endDate).format(format) ]
    },
    updateValues () {
      this.$emit('updateModel', this.getDateFormat(this.state))
    }
  },
  computed: {
    errors: function () {
      return Object.getOwnPropertyNames(this.formHandle).filter(x => {
        return this.formHandle[x] === false && x[0] !== '$'
      })
    },
    formHandle: function () {
      let data = this.name.split('.').reduce((acc, curr) => {
        return acc[curr]
      }, this.handler.form)
      return data
    },
    errorMessage: function () {
      let data = this.name.split('.').reduce((acc, curr) => {
        return acc[curr]
      }, this.formData.errorMessages)
      return data
    }
  }
}
</script>

<style>
.vue-daterange-picker {
  width: 100%;
}
.reportrange-text {
  padding: 0 !important;
  border: none !important;
}
.datepicker-style {
  display: flex;
  align-items: center
}
.datepicker-style > div {
  padding: 5px 10px;
  border: 1px solid #ccc;
  margin: 0 10px;
  flex-grow: 1
}
.datepicker-style > div:first-child {
  margin-left: 0;
}
.datepicker-style > div:last-child {
  margin-right: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/custom/PDatetime.vue